import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="temoignages" className="py-20 bg-slate-200">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Témoignages
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Ce Que Disent
            <span className="block text-sky-600 mt-2">Nos Clients</span>
          </h2>
          <p className="text-lg text-slate-700">
            La satisfaction de nos clients est notre priorité
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gradient-to-br from-white to-slate-100 rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow relative border border-slate-300"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-sky-100">
                <Quote size={40} />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-yellow-400" size={18} />
                ))}
              </div>

              {/* Comment */}
              <p className="text-slate-700 mb-6 leading-relaxed relative z-10">
                "{testimonial.comment}"
              </p>

              {/* Author */}
              <div className="border-t border-slate-100 pt-4">
                <div className="font-bold text-slate-900">{testimonial.name}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-white rounded-full px-6 py-3 shadow-md">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="text-yellow-400 fill-yellow-400" size={20} />
              ))}
            </div>
            <span className="text-slate-700 font-semibold">5,0 sur Google</span>
            <span className="text-slate-500">|</span>
            <span className="text-slate-600">Plus de 30 avis Google</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
